import React from 'react';
import PDFViewer from '../components/pdf_viewer.jsx';
import PDFViewerPortrait from '../components/pdf_viewer_portrait.jsx';
import { Context } from '../services/context.js';
import styles from './marketing.module.css';
import { SEO } from '../components/SEO.jsx';
import heroImage from '../pictures/Library.avif';
import moneyImage from '../pictures/Money Converter.avif';

import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

const pdfPath = '/documents/Money for Modern Times.pdf';

export function Publications() {
  return (
    <main className={styles.page}>
      <SEO
        title="Back-Step Blockchain Publications"
        description="White papers and publications from Blockchain Systems about Back-Step Blockchain, modern digital money, AI accountability, and trusted records."
        path="/publications"
        type="article"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ScholarlyArticle',
          headline: 'Money for Modern Times',
          publisher: 'Blockchain Systems Pte. Ltd.',
          url: 'https://www.backstepchain.com/documents/Money%20for%20Modern%20Times.pdf',
        }}
      />

      <section className={styles.hero}>
        <img className={styles.heroImage} src={heroImage} alt="Library with publications" />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <p className={styles.kicker}>Publications</p>
          <h1 className={styles.heroTitle}>Ideas for modern money and trusted digital records.</h1>
          <p className={styles.heroText}>
            Our papers explain where Back-Step Blockchain can create real-world value: digital currency, secure records, AI accountability, and trusted transactions.
          </p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.documentLayout}>
          <aside className={styles.card}>
            <img className={styles.cardImage} src={moneyImage} alt="Digital money conversion concept" />
            <div className={styles.cardBody}>
              <span className={styles.tag}>White paper</span>
              <h3>Money for Modern Times</h3>
              <p>
                A customer-focused look at how national digital money can become faster, traceable where required, and easier to use in everyday life.
              </p>
              <a className={styles.cardButton} href={pdfPath} target="_blank" rel="noreferrer">Open PDF</a>
            </div>
          </aside>

          <div className={styles.documentPanel}>
            {Context.portrait ? <PDFViewerPortrait file={pdfPath} /> : <PDFViewer file={pdfPath} />}
          </div>
        </div>
      </section>
    </main>
  );
}
